import React from 'react';

import { box, CONTENT_WIDTH, MARGIN_X, pt } from './slideGeometry';

const LOGO_URL = '/images/email/inbudget-logo.png';

/**
 * The cover: logo, title, period and scope, event, preparer, as-at date,
 * revision and who the pack was issued to, each line at the size the
 * Paginator fitted it to (`page.fit`).
 */
const CoverSlide = ({ page }) => {
    const details = [
        page.preparedBy ? $t('Prepared by {{name}}', { name: page.preparedBy }) : null,
        page.asAt ? $t('As at {{date}}', { date: page.asAtLabel || page.asAt }) : null,
        page.revisionLabel || null,
        page.issuedTo ? $t('Issued to {{recipient}}', { recipient: page.issuedTo }) : null,
    ].filter(Boolean);
    const fit = page.fit || {};

    return (
        <>
            {page.logo && <img src={LOGO_URL} alt="InBudget" style={box(MARGIN_X, 48, 168, 36)} />}
            <div className="tw-bg-blue" style={box(0, 172, 8, 150)} />
            <div
                className="tw-text-charcoal tw-font-bold"
                style={{ ...box(MARGIN_X, 170, CONTENT_WIDTH, 48), fontSize: pt(fit.titleSize ?? 32), lineHeight: '48px' }}
            >
                {page.title}
            </div>
            <div className="tw-text-blue" style={{ ...box(MARGIN_X, 224, CONTENT_WIDTH, 28), fontSize: pt(fit.subtitleSize ?? 16) }}>
                {page.subtitle}
            </div>
            <div className="tw-text-charcoal" style={{ ...box(MARGIN_X, 258, CONTENT_WIDTH, 24), fontSize: pt(fit.eventSize ?? 14) }}>
                {page.eventName}
            </div>
            {details.map((line, index) => (
                <div
                    key={index}
                    className="tw-text-charcoal-60"
                    style={{ ...box(MARGIN_X, 300 + index * 20, CONTENT_WIDTH, 20), fontSize: pt(fit.detailSize ?? 11) }}
                >
                    {line}
                </div>
            ))}
        </>
    );
};

export default CoverSlide;
